/**
 * Zod Schemas for Error Types
 *
 * Provides runtime validation schemas for ApiErrorCode and ApiError.
 * These schemas enable validation of error responses at API boundaries.
 *
 * @module schemas/error.zod
 * @see Requirements 3.2, 3.4
 */
import { z } from 'zod';
import { ApiErrorCode } from '../errors/error-codes';
/**
 * Schema for ApiErrorCode enum using z.nativeEnum().
 * Validates that the value is a valid API error code.
 */
export const ApiErrorCodeSchema = z.nativeEnum(ApiErrorCode);
/**
 * Schema for ApiError - unified API error response.
 * Validates code, message, requestId, and optional details fields.
 */
export const ApiErrorSchema = z.object({
    code: ApiErrorCodeSchema,
    message: z.string(),
    requestId: z.string().min(1),
    details: z.record(z.unknown()).optional(),
});
//# sourceMappingURL=error.zod.js.map